import { Link } from 'react-router-dom';
import styled from 'styled-components';

import Button from './ui/Button';

const Background = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background-color: ${(props) => props.theme.global.bgColor};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  line-height: 1;

  & > span:first-child {
    display: block;
    font-size: 100px;
    margin-bottom: 20px;
  }

  & > span {
    display: block;
    font-size: 18px;
    margin-bottom: 30px;
  }
`;

const Error404 = () => {
  return (
    <Background>
      <Container>
        <span>404</span>
        <span>페이지를 찾을 수 없습니다.</span>
        <Link to="/">
          <Button>홈으로</Button>
        </Link>
      </Container>
    </Background>
  );
};

export default Error404;
